import React, { Component } from 'react';
import onClickOutside from 'react-onclickoutside';
import { arraysEqual } from '../utils';

import './LocationFilter.scss';

class LocationFilter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedLocations: [],
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!nextProps.loading && this.props.loading) {
      this.props.closeFilter(this.props.locationType);
    }

    // Update state with already applied filters
    if (
      nextProps.open !== this.props.open &&
      nextProps.appliedLocations &&
      nextProps.appliedLocations !== this.state.selectedLocations
    ) {
      this.setState({ selectedLocations: nextProps.appliedLocations });
    }
  }

  UNSAFE_componentWillUpdate(nextProps, nextState) {
    if (
      this.props.mobile &&
      !arraysEqual(this.state.selectedLocations, nextState.selectedLocations)
    ) {
      this.props.updateMobileFilters(
        nextProps.locationType,
        nextState.selectedLocations
      );
    }
  }

  updateSelectedWithApplied = () => {
    if (this.props.appliedLocations) {
      this.setState({ selectedLocations: this.props.appliedLocations });
    }
  };

  filterButtonClicked = () => {
    if (this.props.open) {
      this.props.closeFilter(this.props.locationType);
    } else {
      this.props.openFilter(this.props.locationType);
    }
  };

  handleClickOutside = (_evt) => {
    if (this.props.open && !this.props.loading && !this.props.mobile) {
      this.props.closeFilter(this.props.locationType);
      this.clearFilter();
    }
  };

  // Clears and applies reset
  clearAndApply = () => {
    this.clearFilter();
    this.props.applyFilter(this.props.locationType, []);
  };

  applyLocationFilters = () => {
    this.props.applyFilter(
      this.props.locationType,
      this.state.selectedLocations
    );
  };

  // Clears all unapplied locations from UI
  clearFilter = () => {
    this.setState({ selectedLocations: [] });
  };

  toggleSwitch = (location) => {
    if (this.isLocationSelected(location)) {
      this.deselectLocation(location);
    } else {
      this.selectLocation(location);
    }
  };

  // Returns whether a location has been selected
  isLocationSelected = (location) => {
    return this.state.selectedLocations.indexOf(location) >= 0;
  };

  // Select a location
  selectLocation = (location) => {
    const selectedLocations = this.state.selectedLocations.slice();
    const index = selectedLocations.indexOf(location);

    if (index < 0) {
      selectedLocations.push(location);
      this.setState({ selectedLocations });
    }
  };

  // Deselect a location
  deselectLocation = (location) => {
    const selectedLocations = this.state.selectedLocations.slice();
    const index = selectedLocations.indexOf(location);

    if (index >= 0) {
      selectedLocations.splice(index, 1);
      this.setState({ selectedLocations });
    }
  };

  filterLabel = () => {
    let labelLocations = null;
    const { open, locationType } = this.props;

    // Capitalize this.props.locationType string
    const locString =
      locationType.charAt(0).toUpperCase() + locationType.slice(1);

    if (open) {
      labelLocations = this.state.selectedLocations;
    } else {
      labelLocations = this.props.appliedLocations;
    }

    if (!labelLocations || labelLocations.length === 0) {
      return locString;
    }
    if (labelLocations.length === 1) {
      return labelLocations[0];
    }
    return `${locString} (${labelLocations.length})`;
  };

  renderLocations = () => {
    const slicedLocations = this.props.locations.slice(0, 10);

    const groupedLocations = [];
    while (slicedLocations.length > 0)
      groupedLocations.push(slicedLocations.splice(0, 5));

    return groupedLocations.map((locations) => {
      const column = locations.map((location) => (
        <div key={location} className="locationOption">
          <div className="name">{location}</div>
          <div
            className={`toggle ${
              this.isLocationSelected(location)
                ? 'selected brand-bg'
                : 'default'
            }`}
            onClick={() => this.toggleSwitch(location)}
          >
            <i className="icon af-checkmark" />
          </div>
        </div>
      ));

      return (
        <div key={locations[0]} className="listColumn">
          {column}
        </div>
      );
    });
  };

  renderClearButton = () => {
    if (this.state.selectedLocations.length > 0) {
      return (
        <div className="clearButton brand-color" onClick={this.clearAndApply}>
          Clear
        </div>
      );
    }
    return <div />;
  };

  renderMobile = () => {
    const locations = this.props.locations.slice(0, 10);
    const locList = locations.map((location, index) => (
      <div
        key={location}
        className={`locationOption ${
          locations.length === index + 1 ? 'last' : ''
        }`}
        onClick={() => this.toggleSwitch(location)}
      >
        <div className="name">{location}</div>
        <div
          className={`toggle ${
            this.isLocationSelected(location) ? 'selected brand-bg' : 'default'
          }`}
        >
          <i className="icon af-checkmark" />
        </div>
      </div>
    ));

    const { locationType } = this.props;

    return (
      <div className="filterBody locationFilter mobile">
        <div className="heading">
          {locationType.charAt(0).toUpperCase() + locationType.slice(1)}
        </div>
        <div className="locationList">{locList}</div>
      </div>
    );
  };

  render() {
    if (!this.props.enabled) return null;
    if (this.props.mobile) return this.renderMobile();

    return (
      <div className="filter">
        <div
          className={`filterButton brand-border
            ${this.props.open ? 'open brand-bg' : null}
            ${this.props.filterApplied ? 'filterApplied brand-bg' : null}`}
          onClick={this.filterButtonClicked}
        >
          {this.filterLabel()}
        </div>

        <div
          className={`filterPopover locationFilterPopover arrow-top
          ${this.props.open ? '' : 'hidden'}
          ${this.props.locations.length > 5 ? 'expanded' : ''}
        `}
        >
          <div className="filterBody locationFilter">
            <div className="locationList">{this.renderLocations()}</div>
            <div className="filterActions">
              {this.renderClearButton()}
              <div
                className={`applyButton submitButton ui fluid button anygreen brand-bg ${
                  this.props.loading ? 'loading' : null
                }`}
                onClick={this.applyLocationFilters}
              >
                Apply
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default onClickOutside(LocationFilter);
